import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "@env/environment";
import { Plan } from "./plan.model";
import { Patient } from "../patient/patient.model";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Discount } from "../plan-editor/plan/plan.model";

const API_ENDPOINT = environment.API_ENDPOINT + "/plans";

@Injectable()
export class PlanService {
  constructor(private http: HttpClient) {}

  searchPlans(query?: string, patient?: Patient): Observable<Plan[]> {
    let params: HttpParams = new HttpParams();
    if (query) {
      params = params.append("q", query);
    }
    if (patient) {
      params = params.append("patient", String(patient.id));
    }

    return this.http.get<Plan[]>(API_ENDPOINT, { params });
  }

  getPlan(planId): Observable<Plan> {
    return this.http.get<Plan>(API_ENDPOINT + "/" + planId);
  }

  createPlan(plan: Plan): Observable<Plan> {
    return this.http.post<Plan>(API_ENDPOINT, {
      name: plan.name,
      patient: plan.patient.id,
    });
  }

  updatePlan(plan: Plan): Observable<Plan> {
    return this.http.put<Plan>(API_ENDPOINT + "/" + plan.id, plan);
  }

  deletePlan(plan: Plan): Observable<Plan> {
    return this.http.delete<Plan>(API_ENDPOINT + "/" + plan.id);
  }

  updatePlanDetails(
    planId: string,
    name: string,
    customTotalText?: string,
    discount?: Discount,
  ): Observable<Plan> {
    return this.http.patch<Plan>(API_ENDPOINT + "/" + planId, {
      name,
      customTotalText,
      discount,
    });
  }

  duplicatePlan(plan: Plan): Observable<Plan> {
    let params: HttpParams = new HttpParams();
    params = params.append("source", plan.id.toString());

    return this.http.post<Plan>(API_ENDPOINT, plan, { params });
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan/plan.service.ts